import React from "react";
import "./errorPage.scss";

const ErrorPage = () => {
  return <div>ErrorPage</div>;
};

export default ErrorPage;
